import { NewsArticle } from '@/lib/news';

interface NewsCardProps {
  article: NewsArticle;
}

const NewsCard = ({ article }: NewsCardProps) => {
  return (
    <div className="bg-white rounded-lg shadow-md p-4 mb-4">
      <h3 className="text-lg font-semibold mb-2">{article.title}</h3>
      <p className="text-gray-600 mb-3">{article.summary}</p>
      <div className="flex justify-between items-center text-sm text-gray-500">
        <span>{article.source.name}</span>
        <span>{new Date(article.publishedAt).toLocaleDateString()}</span>
      </div>
      <a
        href={article.url}
        target="_blank"
        rel="noopener noreferrer"
        className="mt-3 inline-block text-blue-600 hover:text-blue-800"
      >
        Read more →
      </a>
    </div>
  );
};

export default NewsCard; 